module.exports = __webpack_public_path__ + "assets/img/logo_900_900.4f694a88.png";